import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import { getSelf } from './auth.Dux'

export class AuthenticationGate extends Component {
  render() {
    if (!this.props.self.isAuthenticated) return <Redirect to="/" />
    if (window.location.pathname !== '/password' && this.props.self.profile.must_change_password)
      return <Redirect to="/password" />
    return this.props.children
  }
}
const mapStateToProps = (state) => ({
  self: getSelf(state),
})

export default connect(mapStateToProps)(AuthenticationGate)
